module.exports = '<categories-liste></categories-liste>\n';